/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off" */
import React from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Button, Typography, FlexGrid,
} from '@albo-ui/core';
import { Divider } from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

interface SimulationSummary {
    total_customers: number;
    total_fee: number;
    [key: string]: any;
}

interface FeeConfirmModalProps {
    open: boolean;
    summary: SimulationSummary | null;
    period: string;
    segments: string[];
    onConfirm: () => void;
    onClose: () => void;
}

const currencyFmt = (v: number) =>
    new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(v);

export const FeeConfirmModal: React.FC<FeeConfirmModalProps> = ({
    open, summary, period, segments, onConfirm, onClose,
}) => (
    <Dialog open={open} onClose={onClose} style={{ minWidth: '450px' }}>
        <DialogTitle>
            <span style={{ display: 'flex', alignItems: 'center', gap: 8, color: '#f57c00' }}>
                <WarningAmberIcon />
                Confirmar Cobro Real
            </span>
        </DialogTitle>

        <Divider />

        <DialogContent>
            <Typography variant="paragraph" style={{ marginBottom: 15, display: 'block' }}>
                Estás a punto de ejecutar el <strong>Cobro Real</strong> para los siguientes parámetros.
                Esta acción generará movimientos en las cuentas y <strong>no puede deshacerse</strong>.
            </Typography>

            <div style={{ backgroundColor: '#f5f5f5', borderRadius: 4, padding: 15, marginBottom: 15 }}>
                <Typography variant="paragraph" style={{ display: 'block', marginBottom: 5 }}><strong>Período:</strong> {period}</Typography>
                <Typography variant="paragraph" style={{ display: 'block' }}><strong>Segmentos:</strong> {segments?.join(', ')}</Typography>
            </div>

            {summary && (
                <div style={{ backgroundColor: '#1976d2', borderRadius: 4, padding: 15, color: 'white', marginBottom: 15 }}>
                    <Typography variant="paragraph" style={{ display: 'block', color: 'white', marginBottom: 5 }}>
                        <strong>Clientes a cobrar:</strong> {summary.total_customers}
                    </Typography>
                    <Typography variant="paragraph" style={{ display: 'block', color: 'white' }}>
                        <strong>Monto total de fees:</strong> {currencyFmt(summary.total_fee || 0)}
                    </Typography>
                </div>
            )}

            <Typography variant="paragraph" style={{ color: '#969BA0', fontSize: '0.85rem', display: 'block', marginTop: 15 }}>
                Se realizará el cobro a {summary?.total_customers} clientes por {currencyFmt(summary?.total_fee || 0)}. ¿Deseas continuar?
            </Typography>
        </DialogContent>

        <Divider />

        <DialogActions>
            <FlexGrid container fullWidth justify="space-between" alignItems="center">
                <Button buttonType="secondary" onClick={onClose} size="normal">
                    Cancelar
                </Button>
                <Button onClick={onConfirm} size="normal" color='vivere'>
                    Confirmar Cobro Real
                </Button>
            </FlexGrid>
        </DialogActions>
    </Dialog>
);
